import React , { useState , useEffect } from 'react'


import AsyncSelect from 'react-select/async';

import Botones from './Botones';

import { ApiCallGet, ApiCallPost } from '../ApiCall/ApiCall';



export default function Pedidos() {

    const [inputValue,setInputValue] = useState('')

    const [skuValue,setSkuValue] = useState('')

    const [skuVal,setSkuVal] = useState('') ;

    const [cantidad, setCantidad] = useState("0");

    const [discount,setDiscount] = useState( "0")

    const [precio,setPrecio] = useState("0")

    const [observaciones,setObservaciones] = useState( "")

    const [pedidocliente,setPedidoCliente] = useState( "")

    const [showButtons,setShowButtons] = useState( false )

//     const [theList,setTheList] = useState( [ { sku : 'NM8931' , cantidad : '123' , precio : '196.00' , total  : "24,108.00",  faccliente : '039' ,  pedprov : '333' , facprov : '00002' ,observaciones : 'Hola esta es una prueba ' , editar : false } ,
//       { sku   : 'EDT4502' , cantidad   : '4' , precio : '500.00' ,total  : "2,000.00", faccliente : '1234' ,  pedprov : '5679' , facprov : '00001' ,   observaciones : 'Segunda observacion' , editar : false }
//   ])

  const [theList,setTheList] = useState( [])

  const [selected,setSelected] = useState( null )


    function onBotonBorrar( index )
    {
        console.log( "onBotonBorrar = " + index )


        ApiCallGet( "deletepedido/?pedido=" + theList[index].id )
        .then((response) => {
            console.log("response = ", response)        
            var newList = theList.filter( (item , i) => i !== index )

            setTheList( newList )

        })
        .catch((error) => {
            console.log("error = ", error)
        })


    }


    useEffect(() => {
        console.log( "se detecta cambio en theList")
        if( theList.length === 0 )
        {
            setShowButtons( false )
        }
    } , [theList])

    function onPedidoCliente(  )
    {

        var p = document.getElementById( 'pedidocliente').value

        console.log("onPedidoCliente = ", p)

        setPedidoCliente( p )
    }

    function onSetObserva(  )
    {
        var obs = document.getElementById( 'observaciones').value ;

        console.log("onSetObserva = ", obs )

        setObservaciones( obs )
    }

    function onChangeSku( val )
    {
        console.log("onChangeSku = ", val)

        setSkuVal( val )  // JHW3720-TH  val.precio  // 1FOBL7

        var tot = ( val.precio * cantidad ) * ( 1 - discount )
        
        console.log ( "tot = " + tot )

        setPrecio( val.precio )


    }

    function onCuentaChange( val )
    {
        console.log("onCuentaChange*** = ", val)

        // id = val.value 

        // cluentacliente 105.01FOBL7

        //setCuenta( val )

        ApiCallGet( 'descuento/?cuenta='+ val.value )
        .then( (response) => {

            console.log("descuento = ", response)


            if ( response.length > 0 )
            {
                setDiscount( response[0].descuento )
            }

            //setDiscount( response[0].descuento )

        })
        .catch( (error) => {

            console.log("error = ", error)

        })
    }

    function onChangeValue( val )
    {
        console.log( "onChangeValue = " , val )

        setSkuValue( val )
    }

    function onAgregar()
    {
        console.log("onAgregar " + skuValue )
        console.log("skuVal = " + skuVal.label )
        console.log("cantidad = " + cantidad )
        console.log("precio = " + precio )
        console.log("precio original    " + skuVal.precio ) 
        console.log("observaciones = " + observaciones ) 

        // Debemos de validar , antes de proceder

        var precioneto = ( skuVal.precio * cantidad ) * ( 1 - discount )

        var obj = {
            id : 0 ,
            sku : skuVal.label ,
            cantidad : cantidad ,
            precio :  precioneto,  // precio ,
            descuento : discount ,
            total  : cantidad *  precioneto , // skuVal.precio ,
            faccliente : '' ,
            pedprov : '' ,
            facprov : '' ,
            observaciones : observaciones ,
            editar : false
            
        }

        // insertar aqui 






        //console.log( nextElem ) // Aqui lo agregamos a la lista visual

        var registro = {
            SKU : skuVal.label ,
            CANTIDAD : cantidad ,
            VALOR_UNITARIO  : precio ,
            OBSERVACIONES : observaciones ,
            PEDIDO_CLIENTE : pedidocliente ,
            DESCUENTO : discount ,

            dTimeStamp : new Date()

            
        }

        console.log( "resgistro = " , registro )


        ApiCallPost( "savepedido" , registro )
        .then( (response) => {

            console.log("response = ", response)

            setTimeout(() => {
                //console.log("timeout")
                //theList[theList.length-1].id = response ;

                obj.id = response ;

                var nextElem = [
                    ...theList , obj 
                ]

                setTheList( nextElem  )
        
            }, 1000)
            //console.log( "theList = " , theList )


            if ( response > 0)
            {
                alert( "El pedido se ha grabado con exito " )
            }

        })
        .catch( (error) => {

            console.log("error = ", error)

            console.log( "Error al grabar el pedido")

        })


        





    }
    

    function onchangeInput( index )
    {
        

        theList[index].editar = !theList[index].editar ;
        
        console.log( "onchangeInput " , index  + " value = " + theList[index].editar )


        const nextList = theList.map((c, i) => {
            if (i !== index) {
              // Increment the clicked counter

              if ( c.editar === true )
              {
                console.log( "index = " + i + " lo cambiamos a false ") ;
                c.editar = false ;
              }

              return c ;
            } else {
              // The rest haven't changed

              if ( c.editar === true )
              {
                setSelected( index )
                setShowButtons( true  )
              }
              else{
                setSelected( null )
                setShowButtons( false  )
              }
              return c;
            }
          });
          setTheList(nextList);

        
    }

    function getList( index )
    {
        console.log("getList = " + index  , " editar = " + theList[index].editar)
        return(
        <>                     
            <th scope="row">{index+1}</th>
            <td>{theList[index].sku}</td>
            <td>{theList[index].cantidad}</td>
            <td>{theList[index].precio}</td>
            <td>{theList[index].descuento}</td>
            <td>{theList[index].total}</td>
            <td>{theList[index].faccliente}</td>
            <td>{theList[index].facprov}</td>
            <td>{theList[index].pedprov}</td>
            <td>{theList[index].observaciones}</td>
            <td><input key={index} onChange={(val)=>{onchangeInput(index)}} checked={theList[index].editar}  type='checkbox'></input></td>
        </>  )
    }




    // TheList lo debemos de guardar en un state
    // var theList = [ { sku : 'NM8931' , cantidad : '123' , precio : '196.00' , total  : "24,108.00", observaciones : 'Hola esta es una prueba ' , editar : false } ,
    //     { sku   : 'EDT4502' , cantidad   : '4' , precio : '500.00' ,total  : "2,000.00", observaciones : 'Segunda observacion' , editar : false }
    // ]

    const onPrecioChange = (e) => {
        const precio2 = e.target.value;

        //console.log("precio2 = ", precio2)

        if (!precio2 || precio2.match(/^\d{1,}(\.\d{0,4})?$/)) {
          //console.log( "setprecio")
          setPrecio(precio2)
        }
      };


    const onCantidadChange = (e) => {
        const cantidad2 = e.target.value;

        //console.log( "cantidad2 = " , cantidad2)

        if (!cantidad2 || cantidad2.match(/^\d{1,}(\.\d{0,4})?$/)) {
          //console.log( "setcantidad")
          setCantidad(cantidad2)
        }
      };


    const onDiscountChange = e => {
        const amount = e.target.value;
    
        if (!amount || amount.match(/^\d{1,}(\.\d{0,4})?$/)) {
          //this.setState(() => ({ amount }));
          setDiscount(amount)
        }
      };

    const loadSku = (inputValue, callback) => {
        if ( inputValue.length < 3 )
            {
                callback([])
                return ;
            }
    
    
            ApiCallGet('skusprefijo/?prefijo='+inputValue )
            .then((response) => {
    
                console.log( "skuprefijo = " , response )

    
                var theOptions = [] ;
    
                response.forEach((item) => {
    
                    
    
                    theOptions.push( { value : item.idrecuen , label : item.sku , precio : item.precio } )
                })
    
                callback(theOptions)
            })
            .catch((error) => {
                console.log( error )
                callback([])
            })
    
    
      };


    const loadOptions = (inputValue, callback) => {

        if ( inputValue.length < 3 )
        {
            callback([])
            return ;
        }


    


        ApiCallGet('cuentasprefijo/?prefijo='+inputValue )
        .then((response) => {

            console.log( "prefijo = " , response )

            var theOptions = [] ;

            response.forEach((item) => {

                console.log( "forEach = " + item.idcatcue )

                theOptions.push( { value : item.idcatcue , label : item.RFC + " " + item.NOMBRE } )
            })

            callback(theOptions)
        })
        .catch((error) => {
            console.log( error )
            callback([])
        })

        



      };


    function onSelectSku( e )
    {
        //console.log( "Seleccionado value " , e.target.value )
        //console.log( "Seleccionado label " , e.target.label )
    }

    function onSubmit(e){
        e.preventDefault();
    }

  return (
    <div className='box-1 backemployer-2 centersearch w-100 m-1' >
    <div className='d-flex flex-column  box-1 backemployer-2 mb-5 form-2 w-100'  id="page1" style={{fontSize:'16px'}} >

        <div className='row'>
              <div className='col-sm-8'>
                <h5>Administrador de Pedidos</h5>
              </div>
        </div>


        <form className='pt-1' onSubmit={onSubmit} style={{width:'100%' , fontSize :'12px'}}  >


        <div className='row'>

        <div className='col-sm-2'>
                <div className="form-group"  style={{width: "100%"  }} >
                    <label className="form-label m-0" htmlFor="pedidocliente">Pedido Cliente</label>
                    <input  type="text" className="form-group p-lg-2" id="pedidocliente"  onChange={onPedidoCliente}
                    
                    />
                </div>


            </div>


            <div className='col-sm-3'>
                    <div className="form-group"  style={{width: "100%" }} >
                        <label className="form-label m-0" htmlFor="cuenta">Cuenta Cliente</label>

                        <AsyncSelect className='pt-2'
                            id="cuenta" cacheOptions
                            loadOptions={loadOptions} onChange={onCuentaChange}
                            onInputChange={(value) => setInputValue(value)} placeholder="Cuenta"/>

                    </div>


                
            </div>



            <div className='col-sm-3'>


                <div className='row '>

                    {/* <div className='col-sm-6'>
                    <div className="form-group"  style={{width: "100%"  }} >
                        <label className="form-label m-0" htmlFor="descuento">Descuento</label>
                        <input  type="text" className="form-group p-lg-2" 
                         onChange={onDiscountChange} value={discount} id="descuento"  />
                    </div>


                    </div>                 */}

                </div>




            </div>



        </div>

        <div className='row'>

                <div className='col-sm-2'>
                    <label className="form-label m-0" htmlFor="sku">Sku</label>

                    <AsyncSelect className='pt-2' id='sku'
                        loadOptions={loadSku} cacheOptions onChange={(val) => onChangeSku(val)}
                            onInputChange={(val) => onChangeValue(val)}  onChangeValue={onChangeValue}  placeholder="Seleccione Sku"/>

                </div>

                <div className='col-4'>
                    <div className='row'>

                

                        <div className='col-sm-4'>
                            <label className="form-label m-0" htmlFor="cantidad">Cantidad</label>
                            <input type="text" className="form-control" id="cantidad"  
                            value={cantidad} onChange={onCantidadChange}  style={{marginTop:6,height:'40px'}}/>

                        </div>


                        <div className='col-sm-4'>
                            <label className="form-label m-0" htmlFor="precio">Precio de Lista</label>
                            <input type="text" className="form-control" id="precio" onChange={onPrecioChange} value={precio}
                            style={{marginTop:6,height:'40px'}}/>

                        </div>

                        <div className='col-sm-4'>
                            <div className="form-group"  style={{width: "100%"  , marginTop : '0px'}} >
                                <label className="form-label m-0" htmlFor="descuento">Descuento</label>
                                <input  type="text" className="form-group p-lg-2 mt-1" 
                                onChange={onDiscountChange} value={discount} id="descuento"  />
                            </div>
                        </div>


                    </div>
                    
                </div>


              <div className='col-2'>
                  <label className="form-label m-0" htmlFor="observaciones">Observaciones</label>
                  <textarea  className="form-control" id="observaciones" min={0} 
                   style={{marginTop:6,height:'40px'}} onChange={ onSetObserva}/>
                    
              </div>

              <div className='col-3 pt-2'>

                <button type='button' className="btn btn-primary mt-3 button-3"
                  onClick={onAgregar} >Agregar</button>

              </div>





        </div>



        </form>


        <div className='row mt-5'>
              <div className='col-12'>
                <table className="table table-striped" style={{width : '100%'}}>
                  <thead>
                    <tr>
                      <th scope="col">Num</th>
                      <th scope="col">Sku</th>
                      <th scope="col">Cantidad</th>
                      <th scope="col">Precio</th>
                      <th scope="col">Descuento</th>
                      <th scope="col">Total</th>
                      <th scope="col">Factura Cliente</th>
                      <th scope="col">Pedido Proveedor</th>
                      <th scope="col">Factura Proveedor</th>
                      <th scope="col">Observaciones</th>
                      <th scope="col">Editar</th>
                    </tr>
                  </thead>
                  <tbody>

                  {theList.map((value,index) => {
                      return  (<tr>

                        {getList(index)}
                    </tr> );
                  })}
                  </tbody>
                </table>
              </div>
        </div>

        {
            showButtons && (
                <Botones index={selected} botonBorrar={onBotonBorrar}></Botones>
            )
        }
        

    </div>
    </div>

  )
}
